import { geocodeAddresses } from '../DromoUploader/Geocoder'
import { generateSiteActions } from './generateSiteActions'
import {
  IRowToAdd,
  IRowHookInput,
  IRowHookOutputInternal,
} from 'dromo-uploader-js/dist/interfaces'
import { SiteListType } from '@black-bear-energy/black-bear-energy-common'
import { AxiosInstance } from 'axios'
import { repairFailedGeocodes } from '../DromoUploader/repairFailedGeocodes'
import { getSitesNeedingSiteActions } from '../DromoUploader/getSitesNeedingSiteActions'

export async function handleBulkProcessing({
  records,
  isUpdate,
  siteListType,
  api,
  clientId,
}: {
  records: IRowHookInput[]
  isUpdate: boolean
  siteListType: SiteListType
  api: AxiosInstance
  clientId: number
}): Promise<{ newRows: IRowToAdd[]; updatedRows: IRowHookOutputInternal[] }> {
  // geocode sites first
  const geocodedSites = await geocodeAddresses(records, isUpdate, api)

  const { sitesNeedingSiteActions, sitesToSkip } = getSitesNeedingSiteActions(
    isUpdate,
    geocodedSites
  )

  // generate site actions
  const {
    updatedRows: updatedRowsFromGenerateSiteActions,
    newRows,
    siteActionResponse,
  } = await generateSiteActions({
    records: sitesNeedingSiteActions,
    isUpdate,
    siteListType,
    clientId,
    api,
  })

  let updatedRows = updatedRowsFromGenerateSiteActions

  // On the initial run of the bulk row hook,
  // try to fill in addresses for sites that failed geocoding if they match existing records.
  if (!isUpdate) {
    updatedRows = repairFailedGeocodes(updatedRows, siteActionResponse)
  }

  updatedRows = updatedRows.concat(sitesToSkip)
  return { newRows, updatedRows }
}
